import type { MMDFormValues } from "../MMDDialog";

export const usePdpCmnLogic = (): Partial<MMDFormValues> => {
  // Get "cmn" paramater from url. If it exists, return {customerMaterialNumbers: [cmn]}
  const searchParams = new URLSearchParams(window.location.search);
  const cmn = searchParams.get("cmn");
  if (cmn) {
    return {
      customerMaterialNumbers: [cmn],
      filterOrder: ["customerMaterialNumbers"],
    };
  }
  return {};
};
